import React from "react";
import Header from "../components/Header";
import "../assets/css/Naviate.css";
import data from "../assets/config/NaviateArchitecture.json"
import Template from "../components/Template";

export default function NaviateArchitecturePage() {
  return (
    <>
      <Header className="header" name="Architecture" />
      <div className="background-container"></div>
      <Template data={data} />
    </>
  );
}
